import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'finalized', label: 'Finalized' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'period', label: 'Period' },
  { key: 'base_salary', label: 'Base Salary', align: 'right', type: 'money' },
  { key: 'additions', label: 'Additions', align: 'right', type: 'money' },
  { key: 'deductions', label: 'Deductions', align: 'right', type: 'money' },
  { key: 'net_pay', label: 'Net Pay', align: 'right', type: 'money' },
  { key: 'status', label: 'Status' },
];

export function PayrollRegisterReport() {
  return (
    <ReportView
      title="Payroll Register"
      description="Every payroll entry with base salary, additions, deductions and net pay."
      endpoint="/reports/hr/payroll"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
